<template>
    <a href="javascript:void(0)"
          v-if="(stepNumber==3 && index==2)||index<2"
          :class="{'active': index === activeStep, 'completed': step.isCompleted}"
          @click.prevent="onClickBack(index)"
       >
       <span>{{ index + 1 }}</span>
        {{ step.title }}
      </a> 
</template>

<script>

export default {
  components: {
   
  },
  props: ["stepNumber","activeStep","step","index"],
  methods: {
    onClickBack(index){
      if((this.$parent.activeStep==1||this.$parent.activeStep==2)&&index==0){
        this.$parent.backStepOne(); 
      }
      if((this.$parent.activeStep==2)&&index==1){
        this.$parent.backStepTwo();
      }
      if((this.$parent.activeStep==1)&&index==1){
         this.$parent.backStepTwo();
      }
      if((this.$parent.activeStep==2)&&index==2){
        this.$parent.backStepThree();
      }
    }
  },
}
  </script>
